
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 49","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M44.938 9.03H8.364v36.573h36.572V9.03ZM14.852 20.537a3.72 3.72 0 1 0 0-7.441 3.72 3.72 0 0 0 0 7.441Zm6.725-2.954h15.655v-3H21.578v3Zm.338 8.958h15.318v-3H21.915v3Zm15.318 8.958H22.205v-3h15.028v3Zm-18.66-9.683a3.72 3.72 0 1 1-7.442 0 3.72 3.72 0 0 1 7.442 0Zm-3.721 12.721a3.72 3.72 0 1 0 0-7.441 3.72 3.72 0 0 0 0 7.441Z","fill":"#D0EFEC"}}),_c('path',{attrs:{"d":"m14.4 16.039 1.028 1.028 2.009-1.968m-3.13 18.853 1.091 1.09 2.131-2.087m-3.222-7.961 1.091 1.09 2.131-2.087M6.28 6.614h35.612v35.612H6.279V6.614Zm13.372 9.469a3.556 3.556 0 1 1-7.112 0 3.556 3.556 0 0 1 7.112 0Zm0 8.958a3.556 3.556 0 1 1-7.112 0 3.556 3.556 0 0 1 7.112 0Zm0 8.958a3.556 3.556 0 1 1-7.112 0 3.556 3.556 0 0 1 7.112 0Z","stroke":"#234652"}})])
          )
        }
      }
    